import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import SupplementCard from 'components/supplements/SupplementCard'

const styles = (theme) => ({
  //
})

class SupplementList extends React.Component {
  componentDidMount = () => {
    this.props.fetchSupplements()
  }

  render() {
    const { supplements } = this.props
    const productIds = Object.keys(supplements)
    return (
      <Grid spacing={16} justify="center" container>
        {productIds.map((productId) => (
          <Grid key={productId} xs={10} sm={4} md={3} lg={2} item>
            <SupplementCard {...supplements[productId]} />
          </Grid>
        ))}
      </Grid>
    )
  }
}

SupplementList.propTypes = {
  fetchSupplements: PropTypes.func.isRequired,
  supplements: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    .isRequired,
}

// prettier-ignore
export default compose(
  withStyles(styles),
)(SupplementList)



// WEBPACK FOOTER //
// ./src/components/supplements/SupplementList.js